<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field row">
        </div>
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right" :class="`${mode == 'add' ? 'txt-required' : ''}`">Rental
            ID</label>
          <div class="p-col">
            <v-select :disabled="mode == 'edit'" :clearable="false" title="Service" placeholder="Choose"
              v-model="rentalOrder" :options="listRentalOrder" label="code">
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="rentalOrder">
          </div>
        </div>
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right txt-required">Amount</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber v-model="obj_data.amount" :min="0" id="amount" :minFractionDigits="2"
                placeholder="00.00" />
              <span class="p-inputgroup-addon">$</span>

            </div>
          </div>
        </div>

        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right txt-required">Description</label>
          <div class="p-col">
            <textarea maxLength="2000" rows="2" :autoResize="true" v-model="obj_data.description"
              placeholder="Input (max: 2,000 characters)" class="p-inputtext p-component"
              style="width: 99.5%; resize: none;" id="description"></textarea>
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" id="edit" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      available_from_key: 1,
      key_type_id: 1,
      list_unit_duration: [{ id: 1, name: 'Month' }],
      showDeleteDialog: false,
      ListvehicleCategory: [],
      listRentalOrder: [],
      rentalOrder: [],
      obj_data: {}
    };
  },
  async mounted() {
    await this.getLisRentalOrder();
    await this.getLisVehicleCategory();
    if (this.model && Object.keys(this.model).length > 0) {
      this.obj_data = this.$commonFuction.convertJsonObject(this.model);
      this.rentalOrder = this.obj_data?.obj_rental_order ?? null;
      console.log('rentalOrderrentalOrder',this.rentalOrder);
      
    }
  },
  watch: {
    'obj_data.vehicle_category_id'(newVal) {
      if (newVal) {
        this.updateBondFee(newVal);
      }
    }
  },

  methods: {
    async getLisVehicleCategory() {
      try {
        var where_key = { deleted: { _eq: false } };
        var list = await this.$CoreService.getLisVehicleCategory(where_key);
        if (list && list.list) {
          this.ListvehicleCategory = list.list;
        } else {
          console.log('No data returned');
        }
      } catch (error) {
        console.error('Error loading vehicle categories:', error);
      }
    },
    async getLisRentalOrder() {
      try {
        var where_key = {  };
        var list = await this.$CoreService.getLisRentalOrder(where_key);
        if (list && list.list) {
          var list_convert = [];
          for (let i = 0; i < list.list.length; i++) {
            var item = list.list[i];
            var itemDataConvert = {
              id: item.id,
              code: item.code
            }
            if(!this.$commonFuction.isEmpty(this.$route?.query?.id_order)){
              if(this.$route.query.id_order == item.id){
                console.log('itemDataConvert444444444444',itemDataConvert);
                this.rentalOrder = itemDataConvert;
              }
            }
            list_convert.push(itemDataConvert);
          }
          this.listRentalOrder = list_convert;
          // this.listRentalOrder = list.list.map(order => ({
          //   id: order.id,
          //   code: order.code
          // }));
        }
      } catch (error) {
        console.error('Error loading rental orders:', error);
      }
    },
    updateBondFee(selectedCategoryId) {
      if (this.ListvehicleCategory && this.ListvehicleCategory.length > 0) {
        const selectedCategory = this.ListvehicleCategory.find(category => category.id === selectedCategoryId);
        if (selectedCategory) {
          this.$set(this.obj_data, 'bond_fee', selectedCategory.bond_fee);
        }
      }
    },
    async validateData() {
  this.validationErrors = {};

  // Kiểm tra xem this.obj_data có tồn tại không
  if (!this.obj_data) {
    console.error("obj_data is undefined or null.");
    return true; // Trả về true để dừng việc kiểm tra khi obj_data không tồn tại
  }

  // Các trường cần kiểm tra
  const fieldsToValidate = [
    { id: "rentalOrder", value: this.rentalOrder.id },
    { id: "amount", value: this.obj_data.amount },
    { id: "description", value: this.obj_data.description },
  ];
  console.log('fieldsToValidatefieldsToValidate',this.rentalOrder.id);
  let isFormInvalid = false;

  for (let i = 0; i < fieldsToValidate.length; i++) {
    let field = fieldsToValidate[i];
    let inputElement = document.getElementById(field.id);

    if (!inputElement) {
      console.error(`Element with id '${field.id}' not found.`);
      isFormInvalid = true;
      continue; 
    }

    if (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT") {
      if (this.$commonFuction.isEmptyObject(field.value)) {
        inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        isFormInvalid = true;
      }
      else if (field.minValue !== undefined && field.value <= field.minValue) {
        inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        isFormInvalid = true;
      }
      else if (field.maxLength !== undefined && field.value.length > field.maxLength) {
        inputElement.setCustomValidity(`Max length is ${field.maxLength} characters`);
        isFormInvalid = true;
      }
      else {
        inputElement.setCustomValidity("");
      }
    }
  }
  let inpObj = document.getElementById("frm_action");
  if (!inpObj || !inpObj.checkValidity() || isFormInvalid) {
    if (inpObj) {
      inpObj.reportValidity();
    }
    return true;
  }
  return false;
},

backToList() {
      this.$emit('back');
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return; 
      }
      
      
      let params = {
        id: this.obj_data.id,
        rental_order_id: this.rentalOrder.id,
        amount: this.obj_data.amount,
        description: this.obj_data.description,
      };
      console.log('idcuapaymenthistorycapnhat',params);
      this.$emit('save', params);
    }

    ,
  },
};

</script>
<style lang="scss">
.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;
}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}


.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}

.p-col-fixed {
  padding: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #FFDF01 !important;
  }
}
.p-button-outlined .p-button-label {
    color: #000000 !important;
}
.service--product .vs__dropdown-toggle {
  height: 48px;
}

.class-bold1 {
  font-weight: bold;
}
</style>
